<template>
  <div class="ibox">

			<a class="ibox-results-collapse visible-xs" role="button" data-toggle="collapse" href=".ibox-results-filters-collapse-box" aria-expanded="false" aria-controls="ibox-results-filters-collapse-box">
				Show Filters <i class="fa fa-bars"></i>
			</a>
			<div class="ibox-results-filters-collapse-box collapse in">
				<div class="ibox-results-filters">
					<div class="row">
            <div class="col-sm-6 col-lg-4" v-if="$user.isAdminOrCoordinator">
              <div class="form-group">
                <label class="control-label">User</label>
				  <selectize :options="initialUserOptions" v-model="user_id" name="user" :fetch-results="fetchUserResults"></selectize>
			  </div>
            </div>
						<div class="col-sm-6 col-lg-4">
							<div class="form-group">
								<label class="control-label">Search</label>
								<input type="text" class="form-control" placeholder="..." @input="updateSearch" />
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="ibox-content">
        <ul class="list-detail list-detail-truck">
        	<li v-for="truck in trucks" :key="truck.id">
        		<router-link :to="{ name: 'trucks.edit', params: { id: truck.id } }">
        			<img v-if="truck.thumbnail_url" :src="truck.thumbnail_url" alt="truck" />

        			<h2 class="truncate"><strong>{{ truck.registration }}</strong></h2>
              <p class="truncate"><strong>{{ truck.make_and_model }}</strong></p>
        			<ul class="details">
        				<li v-if="truck.location">
                  <span>Depot:</span> {{ truck.location.name }}
                </li>
        				<li v-if="truck.driver">
                  <span>Driver:</span> {{ truck.driver ? `${truck.driver.profile.name} ${truck.driver.profile.surname}` : '' }}
                </li>
        			</ul>
        		</router-link>
        	</li>
        </ul>
        <div class="text-center text-muted" v-show="haveNoTrucks">
          <strong>There are no trucks.</strong>
        </div>
			</div>
      <lazy-loading v-show="haveTrucks" :reached-bottom="getTrucksForNextPage" :filters="filters" ref="lazyLoading">
        <strong slot="finished" class="text-muted">There are no more trucks.</strong>
      </lazy-loading>
		</div>
</template>

<script>
  import { LazyLoading } from 'components/misc'
  import { Selectize } from 'components/forms'
  import { debounce, isEqual, clone } from 'lodash'
  import { mapActions, mapGetters, mapMutations } from 'vuex'
  import { ADD_USER } from 'vx/mutations'
  import { Roles } from 'utils/user'
  export default {
    components: {
      Selectize,
      LazyLoading
    },

    data () {
      return {
        initialUserOptions: [],
        search: '',
        user_id: null
      }
    },

    watch: {
      filters: {
        handler (newFilters, oldFilters) {
          if (isEqual(newFilters, oldFilters)) {
            return
          }

          // Reset the lazy loading component so that it will attempt to load
          // more jobs as we scroll again.
          const resetLazyLoading = () => (this.$refs.lazyLoading.$emit('reset'))

          this.getTrucks(this.filters).then(resetLazyLoading)
        },
        deep: true
      }
    },

    created () {
      this.getTrucks(this.filters)

      const setInitialUserOptions = () => (this.initialUserOptions = clone(this.userOptionsWithAll))

      if (this.$user.isAdminOrCoordinator) {
        this.getUsers({ master: true, roles: [Roles.ADMIN, Roles.COORDINATOR, Roles.CARRIER] }).then(setInitialUserOptions)

        if (this.$route.query.user) {
          this.getUser(this.$route.query.user).then(response => {
            this[ADD_USER](response.data)
            this.$nextTick(() => {
              this.user_id = this.$route.query.user
            })
          })
        }
      }
    },

    computed: {
      ...mapGetters('truck', { trucks: 'trucksDecorated' }),
      ...mapGetters('user', ['userOptionsWithAll']),

      /**
       * Computed filters so we can track deep changes.
       *
       * @return object
       */
      filters () {
        return {
          search: this.search,
          user_id: this.user_id
        }
      },

      /**
       * Determine if we have no trucks.
       *
       * @return boolean
       */
      haveNoTrucks () {
        return this.trucks.length === 0
      },

      /**
       * Determine if we have trucks.
       *
       * @return boolean
       */
      haveTrucks () {
        return this.trucks.length > 0
      }
    },

    methods: {
      ...mapActions('truck', ['getTrucks', 'getTrucksForNextPage']),
      ...mapActions('user', ['getUsers', 'getUser']),
      ...mapMutations('user', [ADD_USER]),

      /**
       * When admin types in the user select box we need to fetch more users
       * from the api since the users are paginated.
       */
      fetchUserResults (name, callback) {
        return this.getUsers({ master: true, roles: [Roles.ADMIN, Roles.COORDINATOR, Roles.CARRIER], name }).then(response => {
          callback(this.userOptionsWithAll)
        })
      },
      /**
       * Debounce updating of keywords so we don't poll API immediately for new trucks.
       *
       * @param object event
       *
       * @return Function
       */
      updateSearch: debounce(function (event) {
        this.search = event.target.value
      }, 800)
    }
  }
</script>



// WEBPACK FOOTER //
// Trucks.vue?cc8d0442